<template>
  <div>
    <TitlePage :title="'Impostazioni Chatbot'"></TitlePage>
    <v-layout wrap>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-subheader>System Prompt</v-subheader>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="systemPrompt"
              label="Istruzioni del chatbot AI"
              rows="20"
              outlined
              hint="Lascia vuoto per usare le istruzioni predefinite di uCamp"
              persistent-hint
              auto-grow
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-btn color="primary" :loading="saving" @click="save">Salva</v-btn>
            <v-btn text class="ml-2" @click="reset">Ripristina predefinito</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">{{ snackbarMsg }}</v-snackbar>
  </div>
</template>

<script>
import TitlePage from '@/components/utils/TitlePage';

export default {
  name: 'ChatbotSettings',
  components: { TitlePage },
  data() {
    return {
      systemPrompt: '',
      saving: false,
      snackbar: false,
      snackbarMsg: '',
      snackbarColor: 'success'
    };
  },
  async created() {
    await this.loadConfig();
  },
  methods: {
    async loadConfig() {
      const result = await this.$store.dispatch('configurations/edit', { name: 'chatbot' });
      this.systemPrompt = (result && result.result && result.result.configurations && result.result.configurations.system_prompt) || '';
    },
    async save() {
      this.saving = true;
      const result = await this.$store.dispatch('configurations/update', {
        name: 'chatbot',
        system_prompt: this.systemPrompt
      });
      this.saving = false;
      if (result && result.success) {
        this.snackbarMsg = 'Impostazioni chatbot salvate';
        this.snackbarColor = 'success';
      } else {
        this.snackbarMsg = 'Errore durante il salvataggio';
        this.snackbarColor = 'error';
      }
      this.snackbar = true;
    },
    reset() {
      this.systemPrompt = '';
    }
  }
};
</script>
